import { message as AntMessage } from 'antd';
import Messages from 'global_config/error_messages';

const defaultDuration = 3;

class Message {
	static info = (messageOrOptions) => {
		// Support both string and options object
		if (typeof messageOrOptions === 'object') {
			AntMessage.info({
				content: messageOrOptions.content || messageOrOptions.message || Messages.genericError,
				duration: messageOrOptions.duration || defaultDuration,
				onClose: messageOrOptions.onClose
			});
		} else {
			AntMessage.info(messageOrOptions || Messages.genericError);
		}
	}

	static error = (messageOrOptions) => {
		// Support both string and options object
		if (typeof messageOrOptions === 'object') {
			AntMessage.error({
				content: messageOrOptions.content || messageOrOptions.message || Messages.genericError,
				duration: messageOrOptions.duration || defaultDuration,
				onClose: messageOrOptions.onClose
			});
		} else {
			AntMessage.error(messageOrOptions || Messages.genericError);
		}
	}

	static warning = (messageOrOptions) => {
		// Support both string and options object
		if (typeof messageOrOptions === 'object') {
			AntMessage.warning({
				content: messageOrOptions.content || messageOrOptions.message || Messages.genericError,
				duration: messageOrOptions.duration || defaultDuration,
				onClose: messageOrOptions.onClose
			});
		} else {
			AntMessage.warning(messageOrOptions || Messages.genericError);
		}
	}

	static success = (param) => {
		AntMessage.success(param.message || Messages.genericError, param.duration || defaultDuration, param.onClose);
	}
}

export default Message;